module.exports = __webpack_public_path__ + "static/media/home-01.daa9a3d3.jpg";